import Vue from "vue";

export default {
  /**
   * Set config
   * @param state
   * @param data
   */
  manualSettings(state, data) {
    // windows config
    if (Object.prototype.hasOwnProperty.call(data, "windowsConfig")) {
      state.windowsConfig = data.windowsConfig;
    }
    // language
    if (Object.prototype.hasOwnProperty.call(data, "lang")) {
      state.lang = data.lang;
    }
    // add new translation
    if (Object.prototype.hasOwnProperty.call(data, "translation")) {
      Vue.set(
        state.translations,
        data.translation.name,
        Object.freeze(data.translation.content)
      );
    }
  },

  /**
   * Initialize App settings from server
   * @param state
   * @param data
   */
  initSettings(state, data) {
    if (!state.lang) state.lang = data.lang;
    if (!state.windowsConfig) state.windowsConfig = data.windowsConfig;
    state.acl = data.acl;
    state.hiddenFiles = data.hiddenFiles;
  },

  /**
   * Set Hide or Show hidden files
   * @param state
   */
  toggleHiddenFiles(state) {
    state.hiddenFiles = !state.hiddenFiles;
  }
};
